import * as actionTypes from '../actions/actionTypes'
import {updateObject} from "../../utility";


const gcpInitialState = {
    dashboard: {overview:{}, byFamily:[], byType: [], byAz: [], projects: []},
    filter: null,
    filterCat: '',
    scope: null,
    plan: null,
    reservationType: '',
    loading: false,
    error: null,
};

const fetchGcpDashboardStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchGcpDashboardSuccess = (state, action) => {
    return updateObject(state, {loading: false, dashboard: action.dashboard, error: null, filter: action.filter,
        filterCat: action.filterCat, scope: action.scope, plan: action.plan})
};

const fetchGcpDashboardFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const changeGcpReservationType = (state, action) => {
    return updateObject(state, {reservationType: action.reservationType})
};

const gcpReducer = (state = gcpInitialState, action) => {
    switch (action.type) {
        case actionTypes.GCP_DASHBOARD_FETCH_START: return fetchGcpDashboardStart(state, action);
        case actionTypes.GCP_DASHBOARD_FETCH_SUCCESS: return fetchGcpDashboardSuccess(state, action);
        case actionTypes.GCP_DASHBOARD_FETCH_FAIL: return fetchGcpDashboardFail(state, action);
        case actionTypes.GCP_DASHBOARD_CHANGE_RESERVATION_TYPE: return changeGcpReservationType(state, action);
        default: return state;
    }
};

export default gcpReducer;
